import type { FromModel, ModelDefinition } from "@/__main__/data-model.mjs";
import createModel, { DeepPartial } from "@/__main__/data-model.mjs";
import { model as appSettings } from "@/data-models/app-settings.mjs";
import { model as userPreferencesModel } from "@/feature-auth/models/user-preferences-model.mjs";

export const requestModel = {
  blitzApp: DeepPartial(appSettings),
} satisfies ModelDefinition;

export type UpdateUserPreferencesRequest = FromModel<typeof requestModel>;

const UpdateUserPreferencesResponseModel = createModel({
  data: { updateUserPreferences: userPreferencesModel },
});

export default UpdateUserPreferencesResponseModel;
